<template>
  
  <header class="header-bd">

        <div id="fundo" class="h-bg bg-fundo"></div>
        <div class="container d-flex py-3 cont h-bg bg-fundo">
          <div class="header_left align-self-center d-flex">
            <div class="logo">
              <img :src="dados.imagem_url" alt="">
            </div>
            <div class="txt d-flex flex-column justify-content-between">
              <h3>{{dados.nome}}</h3>
              <p>{{dados.subtitulo}}</p>
              <div>

                <router-link to="/site" class="btn h-btn m-1" >
                  <i class="fas fa-utensils"> </i>  Cardápio
                </router-link>

                <a v-if="!logado"  @click="modalLogin()" name="" id="" class="btn h-btn m-1" href="#" role="button"><i class="fas fa-user"> </i>  Cadastro</a>
                <template v-else>

                  <router-link to="/site/perfil" class="btn h-btn m-1" >
                    <i class="fas fa-user"> </i> Meu Perfil
                  </router-link>

                  <router-link to="/site/pedidos" class="btn h-btn m-1" >
                    <i class="fa fa-clipboard"> </i> Meus Pedidos
                  </router-link>

                </template>
                

              </div>
              
            </div>
          </div>

          <div class="header_right ml-auto">

            <div class="status">
              <div v-if="status=='Aberto'" style="float:right; padding:5px; background: green">
                  Status: Aberto
              </div>
              <div v-else style="float:right; padding:5px; background: #a90f0f">
                  Status: Fechado
              </div>
            </div>
            <div class="txt">
              <h3>{{dados.fone}}</h3>
              <p>{{dados.endereco}}</p>
            </div>
            <!-- <nav class="menu mt-4">
                <ul class="bg-2">
                  <li>
                    <router-link to="/site/">
                      Home
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/site/quemsomos">
                      Quem Somos
                    </router-link>
                  </li>
                  <li>Meus Pedidos</li>
                </ul>
            </nav> -->
          </div>
        </div>

    </header>


</template>

<script>
import api from "../service/api";
import Cookie from "js-cookie";
export default {

  data() {
        return {
            dados: {},
            expediente: {},
            status:'',

        }
    },

    methods: {
      async carregarDados(){
          await api
          .get('/inquilino')
          .then(response => (this.dados = response.data));
        },

        async carregarExpediente(){
          await api
          .get('/inquilino/expediente')
          .then(response => (this.expediente = response.data));
        },

        async modalLogin(){
          Cookie.set('proximaPagina', 'perfil' );
          await this.$store.dispatch('showModalLogin').then();
          $('#modalLogin').modal('show');
        },

        verificarStatus(){
          api
          .get('/status')
          .then(response => (this.status = response.data.status));
        }
    },

    computed: {
      
        logado() {

          if (JSON.stringify(this.$store.state.perfil.main)==='{}') {
            return false
          }else{
            return true
          }
        },

    },

    mounted () {
        this.carregarDados();
        this.carregarExpediente();
        this.verificarStatus();
    },

}
</script>

<style scoped>

/* *{
  border: 2px solid red;
} */

#fundo {
  content: "";
  height:145px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  filter: blur(3px);
  z-index: -1;
  opacity: 0.85;
}


.cont{
  /* height:150px; */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  box-shadow: 0 0 12px 1px #272727;
}

.header_left{
  width: 100%;
  /* position: relative;
  top: 25px;
  display: inline-flex;
  flex-wrap: wrap; */
}

.header_right{
  /* float: right;
  position: relative;
  top: 25px; */
}

.logo{
  height: 100%;
  border-radius: 20%;
  /* box-shadow: 0 0 12px 1px #666666; */
}

.logo img{
  max-width:300px; 
  max-height:120px; 
  filter: drop-shadow(0 0 6px #666666);
  /* box-shadow: 0 0 12px 1px #666666;
  border-radius: 15px; */
}

.txt{
  margin-left: 1.5rem;
  min-width: 220px;
  text-shadow: 1px 1px 3px black;
}

.header_right .txt h3{
    /* float: right; */
    text-align: right;
}

.header_right .txt p{
    /* float: right; */
    text-align: right;
}

.status{
  color: #fff;
  height: 35px;
}

.menu {
  height: 35px;
}

.menu ul{
  list-style: none;
  height: 35px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

.menu li {
  float: left;
  height: 100%;
  margin: 0 5px;
  padding: 5px;
}


@media only screen and (max-width: 780px) {
  
  .cont{
    /* height:245px; */
  }

  .header_left {
    /* position: relative; */
    /* top: 25px; */
    /* display: inline-flex; */
    /* flex-wrap: wrap; */
    /* text-align: center; */
    flex-direction: column !important;
    place-items: center;
  }

  .logo img{
    max-height: 180px;
  }

  .txt{
    margin-left: 0;
    text-align: center;
  }

  .txt h3{
    margin-top: 10px;
  }

  .header_right{
    display: none;
    float:none;
  }




}


</style>